// extracted by mini-css-extract-plugin
export var container = "dc-video-player-module--container--bqXkz";
export var control = "dc-video-player-module--control--lcej+";
export var controlIcon = "dc-video-player-module--controlIcon--segg7";
export var externalSourceButton = "dc-video-player-module--externalSourceButton--v+Pr+";
export var loader = "dc-video-player-module--loader--Q0gJF";
export var playButton = "dc-video-player-module--playButton--N76aW";
export var scrubber = "dc-video-player-module--scrubber--0nJfI";
export var scrubberHandle = "dc-video-player-module--scrubberHandle--n7b2G";
export var scrubberViewed = "dc-video-player-module--scrubberViewed--nRaHV";
export var spin = "dc-video-player-module--spin--TCjqw";
export var video = "dc-video-player-module--video--pYaBN";
export var volumeButton = "dc-video-player-module--volumeButton--TlvA5";